import React from 'react';
import Button from '../ui/Button';
import './Features.css';

const Features: React.FC = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="features section" id="features">
      <div className="container">
        <h2 className="features__title heading-2 text-center">
          How Furudio Works
        </h2>
        <div className="features__visual">
          <img
            src="/Dependency wheel – muokattu.png"
            alt="Furudio Dependency Wheel showing the full organizational view"
            className="features__image"
          />
        </div>
        <p className="features__caption text-center">
          This is what your organization looks like in Furudio.
        </p>
        <div className="features__cta text-center">
          <Button
            variant="primary"
            size="lg"
            onClick={scrollToContact}
          >
            Book a strategy conversation to see yours
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Features;
